var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"url":_vm.url,"bg-url":_vm.bgUrl,"bg-url2":_vm.bgUrl2,"content":_vm.content,"bg-align":"left-bottom","bg-align2":"right-top","section":"社媒引流"}})
}
var staticRenderFns = []

export { render, staticRenderFns }